export default __webpack_public_path__ + "static/media/EllenPantry.aaf3ffff.jpg";